import { useState } from 'react'
import InputAdornment from '@material-ui/core/InputAdornment'
import { ReactComponent as VisibilityOn } from 'shared/icons/eye_.svg'
import { ReactComponent as VisibilityOff } from 'shared/icons/eye.svg'
import { useField } from 'formik'
import { TextFieldProps } from '@material-ui/core'
import { TextField } from './PasswordInput.style'
import { Icon } from './PasswordInput.style'

interface BasePasswordInputProps {
  name: string
}

type PasswordInputProps = BasePasswordInputProps & TextFieldProps

const PasswordInput = (props: PasswordInputProps) => {
  const [field, meta] = useField(props.name)
  const [showPassword, setShowPassword] = useState(false)
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }
  return (
    <TextField
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <Icon
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              disabled={props.disabled}
            >
              {showPassword ? <VisibilityOn /> : <VisibilityOff />}
            </Icon>
          </InputAdornment>
        ),
      }}
      {...props}
      {...field}
      error={!!(meta.error && meta.touched)}
      helperText={meta.touched ? meta.error : ''}
    />
  )
}

export default PasswordInput
